import React, { useContext, useEffect, useState } from "react";
import {
  IconReportMoney,
  IconPackages,
  IconFileInvoice,
  IconSearch,
  IconPackage,
  IconInfoCircle,
  IconTruckDelivery
} from "@tabler/icons-react";
import { UserServiceContext } from "../services/user/userService";
import Loader from "../components/Loader";
import CustomAlert from "../components/CustomAlert";
import ReactDataTable from "react-data-table-component";
import { paginationComponentOptions } from "../utils/constants";
import PackageInfo from "./app/modals/PackageInfo";
import { Link, useNavigate } from "react-router-dom";
import GeneratePDF from "../components/GeneratePdf";
import { IconDownload, IconPdf } from "@tabler/icons-react";

const Packages = () => {
  const navigate = useNavigate();
  const {
    packagesData,
    loading,
    getDeliveryOrders,
    deliveryOrders,
    deliveryMethods,
    peymentMethods,
    downloadSticker
  } = useContext(UserServiceContext);
  const [openPackageInfo, setOpenPackageInfo] = useState(false);
  const [formData, setFormData] = useState({
    orderActionTypeId: 0,
    dateFrom: "",
    dateTo: "",
  });

  const [alertConfig, setAlertConfig] = useState({
    show: false,
    title: "",
    text: "",
    icon: "",
    onConfirm: null,
    onCancel: null,
  });

  const [searchValue, setSearchValue] = useState("");
  const [selectedRow, setSelectedRow] = useState({});

  const fetchDeliveryOrders = async (actionTypeId) => {
    //console.log(formData);
    if (formData.dateFrom && formData.dateTo) {
      getDeliveryOrders({
        ...formData,
        orderActionTypeId: actionTypeId,
      });
    }
  };

  const handlePackageInfoModal = () => {
    setOpenPackageInfo(!openPackageInfo);
  };

  useEffect(() => {
    const today = new Date();
    const oneMothAgo = new Date(today);
    oneMothAgo.setMonth(today.getMonth() - 1);

    setFormData({
      ...formData,
      dateFrom: oneMothAgo.toISOString(),
      dateTo: today.toISOString(),
    });

    fetchDeliveryOrders(formData.orderActionTypeId);
  }, []);

  useEffect(() => {
    if (formData.dateFrom && formData.dateTo) {
      fetchDeliveryOrders(formData.orderActionTypeId);
    }
  }, [formData.dateFrom, formData.dateTo]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (!searchValue) {
      navigate(`/tracking/${searchValue}`, "_blank", "noopener,noreferrer");
      //console.log(searchValue);
    }
  };

  const handleRadioChange = (e) => {
    // setFormData({
    //   ...formData,
    //   orderActionTypeId: e.target.value,
    // });
    //console.log(e.target.value);
    fetchDeliveryOrders(e.target.value);
  };

  const handleDateChange = (e) => {
    const { id, value } = e.target;
    const selectedDate = new Date(value).toISOString();
    setFormData({
      ...formData,
      [id]: selectedDate,
    });

    fetchDeliveryOrders(formData.orderActionTypeId);
  };

  const handleDownlodSticker = (row) => {
    //console.log(row.docUrl);
    downloadSticker(row.docUrl);
  };
  const handleRowClick = (row) => {

    setSelectedRow(row);
    setOpenPackageInfo(true);
  };

  const keyDown = (e) => {
    e.preventDefault();
    return false;
  };

  const formatDate = (isoString) => {
    if (isoString) {
      const date = new Date(isoString);
      return date.toISOString().split("T")[0];
    }
  };

  const [filters, setFilters] = useState({
    trackingNumber: "",
    senderCity: "",
    receiverCity: "",
    receiverName: "",
    pieceQuantity: "",
    weight: "",
    amount: "",
    orderStatus: "",
  });

  const handleFilterChange = (e, column) => {
    const { value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [column]: value,
    }));
  };

  const filterConfig = [
    { key: "trackingNumber", label: "გზავნილის ნომერი" },
    { key: "senderCity", label: "გამგზავნის ქალაქი" },
    { key: "receiverCity", label: "მიმღების ქალაქი" },
    { key: "receiverName", label: "მიმღები" },
    { key: "pieceQuantity", label: "რაოდენობა" },
    { key: "weight", label: "წონა" },
    { key: "amount", label: "ღირებულება" },
    { key: "orderStatus", label: "სტატუსი" },
  ];

  const customHeader = () => (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", width: "100%", padding: "8px 0" }}>
      {filterConfig.map(({ key, label }) => (
        <input
          key={key}
          type="text"
          className="form-control"
          placeholder={label}
          value={filters[key]}
          onChange={(e) => handleFilterChange(e, key)}
          style={{ flex: "1 1 150px", minWidth: "120px", maxWidth: "200px" }}
        />
      ))}
    </div>
  );
  // const customHeader = () => {
  //   return (
  //     <div className="flex flex-direction-row gap-4 w-full justify-between">
  //       {columns.map((column, index) => (
  //         <div key={index} style={{ marginBottom: "8px" }}>
  //           {column.filter}
  //         </div>
  //       ))}
  //     </div>
  //   );
  // };

  const filterPaths = {
    trackingNumber: (item) => item.trackingNumber,
    senderCity: (item) => item.sender.cityName,
    receiverCity: (item) => item.receiver.cityName,
    receiverName: (item) => item.receiver.name,
    pieceQuantity: (item) => item.orderInfo.pieceQuantity,
    weight: (item) => item.orderInfo.weight,
    amount: (item) => item.orderInfo.amount,
    orderStatus: (item) => item.orderInfo.orderStatus,
  };

  const filteredData = deliveryOrders.filter((item) =>
    Object.keys(filters).every((key) =>
      String(filterPaths[key](item)).toLowerCase().includes(filters[key].toLowerCase())
    )
  );
  
  // const filteredData = deliveryOrders.filter((item) => {

  //   Object.keys(filters).every((key) => {
  //     console.log(item, filters[key].toLowerCase());
  //     return 1;
  //   }
  //     //String(item[key]).toLowerCase().includes(filters[key].toLowerCase())
  //   );
  //   return Object.keys(filters).every((key) =>
  //     String(filterPaths[key](item)).toLowerCase().includes(filters[key].toLowerCase())
  //   );
  // }
  // );

  const makeColumn = (label, filterKey, selector, cellRenderer) => ({
    name: (
      <div style={{ width: "100%", overflow: "visible", display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>
        <div style={{ fontWeight: "600", marginBottom: "4px" }}>{label}</div>
        <div className="relative flex items-center" style={{ overflow: "visible", marginTop: "auto" }}>
          <input
            type="text"
            placeholder={label}
            value={filters[filterKey]}
            onChange={(e) => handleFilterChange(e, filterKey)}
            onClick={(e) => e.stopPropagation()}
            className="w-full rounded border border-gray-300 px-2 py-1 text-sm font-normal focus:outline-none focus:ring-1 focus:ring-blue-400 pr-6"
          />
          {filters[filterKey] && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                setFilters((prev) => ({ ...prev, [filterKey]: "" }));
              }}
              className="absolute right-1 text-gray-400 hover:text-gray-600 text-xs leading-none"
            >
              ✕
            </button>
          )}
        </div>
      </div>
    ),
    selector,
    cell: cellRenderer,
  });

  const customStyles = {
    headCells: {
      style: {
        padding: '8px!important',
        // paddingRight: '8px',
      },
    },
    cells: {
      style: {
        padding: '8px!important',
        // paddingRight: '8px',
      },
    },
  };

  const columns = [
    {
      cell: (row) => (
        <IconInfoCircle
          className="w-[20px] h-[20px] cursor-pointer"
          style={{ width: "40px" }}
          onClick={() => handleRowClick(row)}
        />
      ),
      width: "40px",
      style: { cursor: "pointer", padding: "0!important" },
    },
    {
      name: "PDF",
      cell: (row) => (
        <div className="btn btn-primary">
          <a
            onClick={() => handleDownlodSticker(row)} target="_blank" rel="noopener noreferrer">
            <div className="text-blue-500 hover:text-blue-700">
              <IconPdf size={20} />
            </div>
          </a>
        </div>
      ),
      width: "50px",
      style: { cursor: "pointer", padding: "0!important" },
    },
    makeColumn("გზავნილის ნომერი", "trackingNumber", (row) => row.trackingNumber, (row) => row.trackingNumber),
    makeColumn("გამგზავნის ქალაქი", "senderCity", (row) => row.sender.cityName, (row) => row.sender.cityName),
    makeColumn("მიმღების ქალაქი", "receiverCity", (row) => row.receiver.cityName, (row) => row.receiver.cityName),
    makeColumn("მიმღები", "receiverName", (row) => row.receiver.name, (row) => row.receiver.name),
    makeColumn("რაოდენობა", "pieceQuantity", (row) => row.orderInfo.pieceQuantity, (row) => row.orderInfo.pieceQuantity),
    makeColumn("წონა", "weight", (row) => row.orderInfo.weight, (row) => row.orderInfo.weight),
    makeColumn("ღირებულება", "amount", (row) => row.orderInfo.amount, (row) => row.orderInfo.amount),
    makeColumn("სტატუსი", "orderStatus", (row) => row.orderInfo.orderStatus, (row) => row.orderInfo.orderStatus),

    // {
    //   name: "PDF",
    //   cell: (row) => (
    //     <GeneratePDF
    //       isPackage={true}
    //       deliveryMethods={deliveryMethods}
    //       orderInfo={row.orderInfo}
    //       peymentMethods={peymentMethods}
    //       pieces={[]}
    //       sender={row.sender}
    //       receiver={row.receiver}
    //       selectedCities={{
    //         selectedCities: {
    //           senderCityName: row.sender.cityName,
    //           receiverCityName: row.receiver.cityName,
    //         },
    //       }}
    //     />
    //   ),
    //   width: "70px",
    //   style: { cursor: "pointer" },
    // },
  ];


  return (
    <>
      {openPackageInfo && (
        <PackageInfo
          setCreateEventModal={handlePackageInfoModal}
          packageInfo={selectedRow}
        />
      )}
      <CustomAlert {...alertConfig} />
      {loading && <Loader />}
      <div className="md:px-6 sm:px-3 pt-4">
        <div className="container-fluid">
          <div className="grid xxl:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-2">
            <div className="card bg-card-color rounded-xl p-4 relative border border-dashed border-border-color">
              <div className="flex flex-col justify-between h-full">
                <form onSubmit={handleSearchSubmit}>
                  <label className="form-label mb-5 inline-block">
                    შეიყვანეთ გზავნილის ნომერი
                  </label>
                  <div className="form-control flex w-full">
                    <input
                      type="text"
                      id="team_board_search"
                      className="form-input !rounded-e-none !py-[6px]"
                      placeholder="ძებნა..."
                    />
                    <button
                      className="btn border border-border-color !rounded-s-none"
                      type={"submit"}
                    >
                      <IconSearch className="w-[20px] h-[20px]" />
                      ძიება
                    </button>
                  </div>
                </form>
                <Link
                  to={"/u-delivery-request"}
                  className="btn btn-primary w-full"
                >
                  <IconTruckDelivery className="w-[20px] h-[20px]" />
                  <strong>კურიერის გამოძახება</strong>
                </Link>
              </div>
            </div>
            <div className="card bg-card-color rounded-xl p-4 relative border border-dashed border-border-color">
              <IconReportMoney className="w-[36px] h-[36px]" />
              <h5 className="my-2 text-[16px]/[20px] font-medium">
                სულ დახარჯული {packagesData?.amountPayed} ₾
              </h5>
              <div className="flex flex-wrap justify-between text-font-color-100">
                <span>ჩარიცხული თანხა :</span>
                <span>{packagesData?.amountPayed} ₾</span>
              </div>
              <div className="flex flex-wrap justify-between text-font-color-100">
                <span>ინვოისების თანხა :</span>
                <span>{packagesData?.amountByInvoices} ₾</span>
              </div>
              <div className="flex flex-wrap justify-between text-font-color-100">
                <span>ნაშთი :</span>
                <span>{packagesData?.amountBalance} ₾</span>
              </div>
            </div>
            <div className="card bg-card-color rounded-xl p-4 relative border border-dashed border-border-color">
              <IconPackages className="w-[36px] h-[36px]" />
              <h5 className="my-2 text-[16px]/[20px] font-medium">
                გზავნილები
              </h5>
              <div className="flex flex-wrap justify-between text-font-color-100">
                <span>რაოდენობა :</span>
                <span>{deliveryOrders.length} </span>
              </div>
            </div>
            <div className="card bg-card-color rounded-xl p-4 relative border border-dashed border-border-color">
              <IconFileInvoice className="w-[36px] h-[36px]" />
              <h5 className="my-2 text-[16px]/[20px] font-medium">ინვოისები</h5>
              <div className="flex flex-wrap justify-between text-font-color-100">
                <span>თანხა :</span>
                <span>{packagesData?.amountUnPayedInvoices} ₾</span>
              </div>
            </div>
          </div>
          <div className="flex  gap-4 border border-border-color rounded-s-md mr-[-1px] py-[6px] px-[12px] bg-body-color mt-20">
            <div className="flex flex-direction-row justify-between w-full">
              <div className="flex flex-direction-row">
                <div className="form-radio">
                  <input
                    type="radio"
                    id="campaignsEmail"
                    name="orderActionTypeId"
                    className="form-radio-input"
                    defaultChecked
                    value={0}
                    onChange={(e) => handleRadioChange(e)}
                  />
                  <label className="form-radio-label" htmlFor="campaignsEmail">
                    გაგზავნილი
                  </label>
                </div>
                <div className="form-radio ml-10">
                  <input
                    type="radio"
                    id="campaignsStack"
                    name="orderActionTypeId"
                    className="form-radio-input"
                    value={1}
                    onChange={(e) => handleRadioChange(e)}
                  />
                  <label className="form-radio-label" htmlFor="campaignsStack">
                    მიღებული
                  </label>
                </div>
              </div>
              <div className="flex flex-direction-row">
                <div>
                  <label htmlFor="dateFrom" className="form-label">
                    თარიღიდან :
                  </label>
                  <input
                    type="date"
                    lang="ka-GE"
                    id="dateFrom"
                    className="form-control"
                    onKeyDown={keyDown}
                    value={formatDate(formData.dateFrom)}
                    onChange={(e) => handleDateChange(e)}
                  />
                </div>
                <div className="ml-10">
                  <label htmlFor="dateTo" className="form-label">
                    თარიღამდე :
                  </label>
                  <input
                    type="date"
                    id="dateTo"
                    className="form-control"
                    onKeyDown={keyDown}
                    value={formatDate(formData.dateTo)}
                    onChange={(e) => handleDateChange(e)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="react-data-table mt-20">
            <ReactDataTable
              customStyles={customStyles}
              onRowClicked={handleRowClick}
              columns={columns}
              pagination
              striped
              data={filteredData}
              paginationComponentOptions={paginationComponentOptions}
              persistTableHead
              // subHeader
              // subHeaderComponent={customHeader()}
              noDataComponent={
                <div
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    color: "gray",
                  }}
                >
                  გზავნილები არ გაქვთ
                </div>
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Packages;
